import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { sendFCMNotifications, sendTextLocalSMS } from '../shared/mobileOTP';
import * as fs from 'fs';
import { ProfileService } from '../profile/profile.service';
import { VillageService } from '../village/village.service';
import { NotificationsEntity } from '../notifications/notifications.entity';
import { IdeaEntity } from './idea.entity';
import { IdeaFilesEntity } from './ideafiles.entity';
import { DeleteIdeaDto, IdeaDTO, LikeIdeaDto } from './dto/idea.dto';
import { AllIdeaResponseModel, IdeaResponseModel, SignalIdeaResponseModel } from './idea-response-module';
import { IdeaActivityEntity } from './idea-activity.entity';


@Injectable()
export class IdeaService {
    constructor (
        @InjectRepository(IdeaEntity)
        private ideaRepo: Repository<IdeaEntity>, 
        @InjectRepository(IdeaFilesEntity)
        private ideafilesRepo: Repository<IdeaFilesEntity>,
        @InjectRepository(IdeaActivityEntity)
        private ideactivityRepo:Repository<IdeaActivityEntity>, 
        @InjectRepository(NotificationsEntity)
        private notifyRepo:Repository<NotificationsEntity>,
        private profileService: ProfileService,
        private villageService:VillageService,
    ) {}    
    
    async sendSMS(mobileNo:string, text: string,id:string) {
        return await sendTextLocalSMS(mobileNo, text,id)
        .then(() => {      
          console.log('sms sent successufully');
          return true;
        })
        .catch((err) => {
          console.log('error in sending sms ', err);
          return false;
        });
    }

    async sendNotify(text) {
        return await sendFCMNotifications(text)
        .then(() => {      
          console.log('notification sent successufully');
          return true;
        })
        .catch((err) => {
          console.log('error in sending notification ', err);
          return false;
        });
    }
      
    async createIdea(queryParams, iDTO:IdeaDTO) {
        try {
            iDTO.status = true;
            iDTO.createdUser=iDTO.userId;
            const user = await this.profileService.getUserByUId(iDTO.userId);
            user.firstName = user.firstName != null? user.firstName:'';
            if(queryParams.apiVersion == 1) {
                const savedPost = await this.ideaRepo.save(iDTO);  
                if(savedPost) {
                    const sentSMS = await this.sendSMS(iDTO.mobileNo, `Your Idea is registered by ${user.firstName}, your Idea ID is ${savedPost.Id} Please download netR App to get updates at Androd users : https://rb.gy/osvnjn and IOS users : https://rb.gy/6yhhus - SRI VARAHA SOLUTIONS`,process.env.BlkSMS_REPRS_TEMPID);
                    let msg = {
                        to : `${user.user.fcmToken}`,
                        collapse_key : "type_a",
                        notification : {
                            body : `Your Idea Created with ${savedPost.Id}`,
                            title: "Create Idea"
                        },
                        data : {
                            body : `Your Idea Created  with ${savedPost.Id}`,
                            title: "Create Idea",
                            key_1 : "",
                            key_2 : ""
                        }
                    }
                    if(user.user.fcmToken) {
                        await this.notifyRepo.save({
                            title:'Create Idea',
                            message:`Your Idea Created with ${savedPost.Id}`,
                            typeId:7,
                            userId:iDTO.userId,
                            targetId:savedPost.Id,
                            status:true
                        })
                        const nt = await this.sendNotify(msg);
                    }
                    const newUsr = await this.profileService.getProfileByPhone(iDTO.mobileNo);
                    if(newUsr) {
                        let msg1 = {
                            to : `${newUsr.user.fcmToken}`,
                            collapse_key : "type_a",
                            notification : {
                                body : `Your Idea is registered by ${user.firstName}, your Idea ID is ${savedPost.Id}`,
                                title: "Create Idea"
                            },
                            data : {
                                body : `Your Idea is registered by ${user.firstName}, your Idea ID is ${savedPost.Id}`,
                                title: "Create Idea",
                                key_1 : "",
                                key_2 : ""
                            }
                        }
                        await this.notifyRepo.save({
                            title:'Create Idea',
                            message:`Your Idea is registered by ${user.firstName}, your Idea ID is ${savedPost.Id}`,
                            typeId:7,
                            userId:newUsr.userId,
                            targetId:savedPost.Id,
                            status:true
                        })
                        
                        if(newUsr.user.fcmToken) {
                            await this.sendNotify(msg1);
                        }
                    }
                    return savedPost;
                } else {
                    return null;
                }
            } else {
                const savedPost = await this.ideaRepo.save(iDTO);  
                if(savedPost) {
                    const sentSMS = await this.sendSMS(iDTO.mobileNo, `Your Idea is registered by ${user.firstName}, your Idea ID is ${savedPost.Id} Please download netR App to get updates at Androd users : https://rb.gy/osvnjn and IOS users : https://rb.gy/6yhhus - SRI VARAHA SOLUTIONS`,process.env.BlkSMS_REPRS_TEMPID);
                    let msg = {
                        to : `${user.user.fcmToken}`,
                        collapse_key : "type_a",
                        notification : {
                            body : `Your Idea Created with ${savedPost.Id}`,
                            title: "Create Idea"
                        },
                        data : {
                            body : `Your Idea Created  with ${savedPost.Id}`,
                            title: "Create Idea",
                            key_1 : "",
                            key_2 : ""
                        }
                    }
                    if(user.user.fcmToken) {
                        await this.notifyRepo.save({
                            title:'Create Idea',
                            message:`Your Idea Created with ${savedPost.Id}`,
                            typeId:7,
                            userId:iDTO.userId,
                            targetId:savedPost.Id,
                            status:true
                        })
                        const nt = await this.sendNotify(msg);
                    }
                    const newUsr = await this.profileService.getProfileByPhone(iDTO.mobileNo);
                    if(newUsr) {
                        let msg1 = {
                            to : `${newUsr.user.fcmToken}`,
                            collapse_key : "type_a",
                            notification : {
                                body : `Your Idea is registered by ${user.firstName}, your Idea ID is ${savedPost.Id}`,
                                title: "Create Idea"
                            },
                            data : {
                                body : `Your Idea is registered by ${user.firstName}, your Idea ID is ${savedPost.Id}`,
                                title: "Create Idea",
                                key_1 : "",
                                key_2 : ""
                            }
                        }
                        await this.notifyRepo.save({
                            title:'Create Idea',
                            message:`Your Idea is registered by ${user.firstName}, your Idea ID is ${savedPost.Id}`,
                            typeId:7,
                            userId:newUsr.userId,
                            targetId:savedPost.Id,
                            status:true
                        })
                        
                        if(newUsr.user.fcmToken) {
                            await this.sendNotify(msg1);
                        }
                    }
                    return savedPost;
                } else {
                    return null;
                }
            }
        }
        catch (error) {
            throw error;
        
        }
    }

    async createIdeaFiles(queryParams, filesData, repId): Promise<IdeaResponseModel> {
        const response = new IdeaResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                let images: any[] = [];
                const fileUpload = await this.ideafilesRepo.save(filesData);
                if(fileUpload) {
                    const data = await this.ideaRepo.findOne({
                        where:{Id:repId}
                    })                    
                    const user = await this.profileService.getUserByUId(data.userId);
                    const village = await this.villageService.getVillageById(data.villageId);
                    const postImages = await this.ideafilesRepo.find({
                        where:{ideaId:data.Id}
                    });
                    if(postImages) {
                        postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                        })
                    }
                    const final = {
                        Id: data.Id,
                        text:data.text,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        mobileNo: data.mobileNo,
                        email: data.email,
                        address: data.address,
                        villageId:data.villageId,
                        villageName:village!=null?village.villageName:'',
                        createdAt:data.createdAt,
                        userId:data.userId,
                        userName: user.firstName,
                        profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                        likeCount:0,
                        likeStatus:false,
                        postImages:images,                        
                    }
                    response.status = true;
                    response.data   = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'Idea saved successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Idea not saved')
                }
            } else {
                let images: any[] = [];
                const fileUpload = await this.ideafilesRepo.save(filesData);
                if(fileUpload) {
                    const data = await this.ideaRepo.findOne({
                        where:{Id:repId}
                    })                    
                    const user = await this.profileService.getUserByUId(data.userId);
                    const village = await this.villageService.getVillageById(data.villageId);
                    const postImages = await this.ideafilesRepo.find({
                        where:{ideaId:data.Id}
                    });
                    if(postImages) {
                        postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                        })
                    }
                    const final = {
                        Id: data.Id,
                        text:data.text,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        mobileNo: data.mobileNo,
                        email: data.email,
                        address: data.address,
                        villageId:data.villageId,
                        villageName:village!=null?village.villageName:'',
                        createdAt:data.createdAt,
                        userId:data.userId,
                        userName: user.firstName,
                        profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                        likeCount:0,
                        likeStatus:false,
                        postImages:images,                        
                    }
                    response.status = true;
                    response.data   = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'Idea saved successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Idea not saved')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async updateIdea(queryParams, filesData, iDTO:IdeaDTO): Promise<IdeaResponseModel> {
        const response = new IdeaResponseModel();
        try {
            const oldData = await this.ideaRepo.findOne({
                where:{Id:iDTO.Id}
            })
            if(iDTO.text) {
                iDTO.text = iDTO.text
            } else {
                iDTO.text = oldData.text
            }
            if(iDTO.mobileNo) {
                iDTO.mobileNo = iDTO.mobileNo
            } else {
                iDTO.mobileNo = oldData.mobileNo
            }
            if(iDTO.firstName) {
                iDTO.firstName = iDTO.firstName
            } else {
                iDTO.firstName = oldData.firstName
            }
            if(iDTO.lastName) {
                iDTO.lastName = iDTO.lastName
            } else {
                iDTO.lastName = oldData.lastName
            }
            if(iDTO.address) {
                iDTO.address = iDTO.address
            } else {
                iDTO.address = oldData.address
            }
            if(iDTO.villageId) {
                iDTO.villageId = iDTO.villageId
            } else {
                iDTO.villageId = oldData.villageId
            }
            if(iDTO.email) {
                iDTO.email = iDTO.email
            } else {
                iDTO.email = oldData.email
            }
            if(iDTO.versionFlag) {
                iDTO.versionFlag = iDTO.versionFlag
            } else {
                iDTO.versionFlag = oldData.versionFlag
            }
            iDTO.updatedUser = iDTO.userId;
            let images: any[] = [];
            let finaObj = {
                text:iDTO.text,
                mobileNo:iDTO.mobileNo,
                firstName:iDTO.firstName,
                lastName:iDTO.lastName,
                address:iDTO.address,
                villageId:iDTO.villageId,
                email:iDTO.email,
                userId:iDTO.userId,
                updatedUser:iDTO.updatedUser
            }
            if(queryParams.apiVersion == 1) {
                const updatedData = await this.ideaRepo.update(iDTO.Id,finaObj);
                const getOldFiles = await this.ideafilesRepo.find({
                    where:{ideaId:iDTO.Id}
                })
                if(getOldFiles.length > 0 && filesData.length > 0)  {
                    getOldFiles.map((f) => {
                        var fname = f.attachmentsUrl.split('/')[2];
                        fs.unlinkSync('./public/ideaImages/'+fname);
                    })
                    await this.ideafilesRepo.delete({ideaId:iDTO.Id});
                }
                const fileUpload = await this.ideafilesRepo.save(filesData);
                const data = await this.ideaRepo.findOne({
                    where: {Id:iDTO.Id},
                });
                if(!updatedData) {
                    throw new ErrorResponse(99908,'Idea record update failed')
                }
                const user = await this.profileService.getUserByUId(data.userId);
                const village = await this.villageService.getVillageById(data.villageId);
                const postImages = await this.ideafilesRepo.find({
                    where:{ideaId:data.Id}
                });
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                    })
                }
                const likedata = await this.ideactivityRepo.find({
                    where:{ideaId:data.Id,like:true}
                })
                if(likedata) {
                    var icount = likedata.length;
                } else {
                    var icount = 0;
                }
                const data1 = await this.ideactivityRepo.findOne({
                    where:{ideaId:data.Id, userId:iDTO.userId}
                })
                if(data1) {
                    var ista = data1.like;
                } else {
                    var ista = false;
                }
                const final = {
                    Id: data.Id,
                    text:data.text,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    mobileNo: data.mobileNo,
                    email: data.email,
                    address: data.address,
                    villageId:data.villageId,
                    villageName:village!=null?village.villageName:'',
                    createdAt:data.createdAt,
                    userId:data.userId,
                    userName: user.firstName,
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    likeCount:icount,
                    likeStatus:ista,
                    postImages:images,                        
                }
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Idea record updated';
                response.intlCode = 11108;
                response.data = final;
            } else  {
                const updatedData = await this.ideaRepo.update(iDTO.Id,finaObj);
                const getOldFiles = await this.ideafilesRepo.find({
                    where:{ideaId:iDTO.Id}
                })
                if(getOldFiles.length > 0 && filesData.length > 0)  {
                    getOldFiles.map((f) => {
                        var fname = f.attachmentsUrl.split('/')[2];
                        fs.unlinkSync('./public/ideaImages/'+fname);
                    })
                    await this.ideafilesRepo.delete({ideaId:iDTO.Id});
                }
                const fileUpload = await this.ideafilesRepo.save(filesData);
                const data = await this.ideaRepo.findOne({
                    where: {Id:iDTO.Id},
                });
                if(!updatedData) {
                    throw new ErrorResponse(99908,'Idea record update failed')
                }
                const user = await this.profileService.getUserByUId(data.userId);
                const village = await this.villageService.getVillageById(data.villageId);
                const postImages = await this.ideafilesRepo.find({
                    where:{ideaId:data.Id}
                });
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                    })
                }
                const likedata = await this.ideactivityRepo.find({
                    where:{ideaId:data.Id,like:true}
                })
                if(likedata) {
                    var icount = likedata.length;
                } else {
                    var icount = 0;
                }
                const data1 = await this.ideactivityRepo.findOne({
                    where:{ideaId:data.Id, userId:iDTO.userId}
                })
                if(data1) {
                    var ista = data1.like;
                } else {
                    var ista = false;
                }
                const final = {
                    Id: data.Id,
                    text:data.text,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    mobileNo: data.mobileNo,
                    email: data.email,
                    address: data.address,
                    villageId:data.villageId,
                    villageName:village!=null?village.villageName:'',
                    createdAt:data.createdAt,
                    userId:data.userId,
                    userName: user.firstName,
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    likeCount:icount,
                    likeStatus:ista,
                    postImages:images,                        
                }
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Idea record updated';
                response.intlCode = 11108;
                response.data = final;
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
	
    async getAllIdeas(queryParams,userId,request:Request):Promise<AllIdeaResponseModel> {
        const response = new AllIdeaResponseModel();
        //where: [{status: true,userId:userId},
        //    {status:true,mobileNo:user.mobileNo}],
        try {
            let images: any[] = [];
            const finalData: any[] = [];
            const user = await this.profileService.getUserByUId(userId);
            if(queryParams.apiVersion == 1) {
                const data = await this.ideaRepo.find({
                    where: [{status: true,userId:userId},
                        {status:true,mobileNo:user.mobileNo}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take: 10
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = data.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.userId);
                    const village = await this.villageService.getVillageById(post.villageId);
                    const postImages = await this.ideafilesRepo.find({
                        where:{ideaId:post.Id}
                    });
                    const likedata = await this.ideactivityRepo.find({
                            where:{ideaId:post.Id,like:true}
                    })
                    if(likedata) {
                            var icount = likedata.length;
                    } else {
                        var icount = 0;
                    }
                    const data1 = await this.ideactivityRepo.findOne({
                        where:{ideaId:post.Id, userId:userId}
                    })
                    if(data1) {
                        var ista = data1.like;
                    } else {
                        var ista = false;
                    }
                    return {
                        Id: post.Id,
                        text:post.text,
                        firstName: post.firstName,
                        lastName: post.lastName,
                        mobileNo: post.mobileNo,
                        email: post.email,
                        address: post.address,
                        villageId:post.villageId,
                        villageName:village!=null?village.villageName:'',
                        createdAt:post.createdAt,
                        userId:post.userId,
                        userName: user!=null?user.firstName:'',
                        profilePic:user!=null?user.profilePic:null,
                        likeCount:icount,
                        likeStatus:ista,
                        postImages:postImages,
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {  
                    if(f.postImages) {
                        f.postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                        })
                    }                        
                    finalData.push({
                        Id: f.Id,
                        text:f.text,
                        firstName: f.firstName,
                        lastName: f.lastName,
                        mobileNo: f.mobileNo,
                        email: f.email,
                        address: f.address,
                        villageId:f.villageId,
                        villageName:f.villageName,
                        createdAt:f.createdAt,
                        userId:f.userId,
                        userName: f.firstName,
                        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                        likeCount:f.likeCount,
                        likeStatus:f.likeStatus,
                        postImages:images,                        
                    }) 
                    images=[];
                }) 
                response.status = true;
                response.data = finalData;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;              
            }  else {
                const data = await this.ideaRepo.find({
                    where: [{status: true,userId:userId},
                        {status:true,mobileNo:user.mobileNo}],
                    order: { createdAt: 'DESC' },
                    skip:queryParams.skip,
                    take: 10
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = data.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.userId);
                    const village = await this.villageService.getVillageById(post.villageId);
                    const postImages = await this.ideafilesRepo.find({
                        where:{ideaId:post.Id}
                    });
                    const likedata = await this.ideactivityRepo.find({
                            where:{ideaId:post.Id,like:true}
                    })
                    if(likedata) {
                            var icount = likedata.length;
                    } else {
                        var icount = 0;
                    }
                    const data1 = await this.ideactivityRepo.findOne({
                        where:{ideaId:post.Id, userId:userId}
                    })
                    if(data1) {
                        var ista = data1.like;
                    } else {
                        var ista = false;
                    }
                    return {
                        Id: post.Id,
                        text:post.text,
                        firstName: post.firstName,
                        lastName: post.lastName,
                        mobileNo: post.mobileNo,
                        email: post.email,
                        address: post.address,
                        villageId:post.villageId,
                        villageName:village!=null?village.villageName:'',
                        createdAt:post.createdAt,
                        userId:post.userId,
                        userName: user!=null?user.firstName:'',
                        profilePic:user!=null?user.profilePic:null,
                        likeCount:icount,
                        likeStatus:ista,
                        postImages:postImages,
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {  
                    if(f.postImages) {
                        f.postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                        })
                    }                        
                    finalData.push({
                        Id: f.Id,
                        text:f.text,
                        firstName: f.firstName,
                        lastName: f.lastName,
                        mobileNo: f.mobileNo,
                        email: f.email,
                        address: f.address,
                        villageId:f.villageId,
                        villageName:f.villageName,
                        createdAt:f.createdAt,
                        userId:f.userId,
                        userName: f.firstName,
                        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                        likeCount:f.likeCount,
                        likeStatus:f.likeStatus,
                        postImages:images,                        
                    }) 
                    images=[];
                }) 
                response.status = true;
                response.data = finalData;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;              
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getIdeaById(queryParams,Id,request:Request):Promise<SignalIdeaResponseModel> {
        const response = new SignalIdeaResponseModel();
        try {
            let images: any[] = [];
            if(queryParams.apiVersion == 1) {
                const data = await this.ideaRepo.findOne({
                    where: {Id:Id},
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const user = await this.profileService.getUserByUId(data.userId);
                const village = await this.villageService.getVillageById(data.villageId);
                const postImages = await this.ideafilesRepo.find({
                    where:{ideaId:data.Id}
                });
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                    })
                }
                const final = {
                    Id: data.Id,
                    text:data.text,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    mobileNo: data.mobileNo,
                    email: data.email,
                    address: data.address,
                    villageId:data.villageId,
                    villageName:village!=null?village.villageName:'',
                    createdAt:data.createdAt,
                    userId:data.userId,
                    userName: user.firstName,
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    postImages:images,                        
                }
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;
            } else {
                const data = await this.ideaRepo.findOne({
                    where: {Id:Id},
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const user = await this.profileService.getUserByUId(data.userId);
                const village = await this.villageService.getVillageById(data.villageId);
                const postImages = await this.ideafilesRepo.find({
                    where:{ideaId:data.Id}
                });
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.attachmentsUrl}`)
                    })
                }
                const final = {
                    Id: data.Id,
                    text:data.text,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    mobileNo: data.mobileNo,
                    email: data.email,
                    address: data.address,
                    villageId:data.villageId,
                    villageName:village!=null?village.villageName:'',
                    createdAt:data.createdAt,
                    userId:data.userId,
                    userName: user.firstName,
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    postImages:images,                        
                }
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;
            }  
            return response;
        } catch (error) {
            throw error;
        }
    }

    async likeIdea(queryParams,lDto:LikeIdeaDto, request:Request):Promise<IdeaResponseModel> {
        const response = new IdeaResponseModel();
        try {
            const checkRec = await this.ideactivityRepo.findOne({
                where:{userId:lDto.userId,ideaId:lDto.ideaId}
            })
            if(queryParams.apiVersion == 1) {
                if(checkRec) {
                    const update = await this.ideactivityRepo.update(checkRec.Id,{like:lDto.like,versionFlag:lDto.versionFlag});
                    if(update) {
                        const data = await this.ideactivityRepo.find({
                            where:{ideaId:lDto.ideaId,like:true}
                        })
                        if(data) {
                            var icount = data.length;
                        } else {
                            var icount = 0;
                        }
                        const data1 = await this.ideactivityRepo.findOne({
                            where:{ideaId:lDto.ideaId, userId:lDto.userId}
                        })
                        if(data1) {
                            var ista = data1.like;
                        } else {
                            var ista = false;
                        }
                        response.status = true;
                        response.data = {
                            ideaId:lDto.ideaId,
                            userId:lDto.userId,
                            likeCount:icount,
                            likeStatus:ista
                        }
                        response.statusCode = 50000;
                        response.internalMessage = lDto.like == true? 'Idea liked successfully':'Idea like removed successfully';
                        response.intlCode = 11108;
                    } else {
                        if(lDto.like == true) throw new ErrorResponse(99998, 'Idea like failed')
                        if(lDto.like == false) throw new ErrorResponse(99998, 'Failed to remove idea like')
                    }
                } else {
                    const save = await this.ideactivityRepo.save(lDto)
                    if(save) {
                        const data = await this.ideactivityRepo.find({
                            where:{ideaId:lDto.ideaId,like:true}
                        })
                        if(data) {
                            var icount = data.length;
                        } else {
                            var icount = 0;
                        }
                        const data1 = await this.ideactivityRepo.findOne({
                            where:{ideaId:lDto.ideaId, userId:lDto.userId}
                        })
                        if(data1) {
                            var ista = data1.like;
                        } else {
                            var ista = false;
                        }
                        response.status = true;
                        response.data = {
                            ideaId:lDto.ideaId,
                            userId:lDto.userId,
                            likeCount:icount,
                            likeStatus:ista
                        }
                        response.statusCode = 50000;
                        response.internalMessage =  'Idea liked successfully';
                        response.intlCode = 11108;
                    }else {
                        throw new ErrorResponse(99998, 'Idea like failed')
                    }
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async deleteIdea(queryParams,delDto:DeleteIdeaDto, request:Request):Promise<IdeaResponseModel> {
        const response = new IdeaResponseModel();
        try {
            const updateRole = await this.ideaRepo.update(delDto.Id, delDto);
            if(updateRole) {
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Idea deleted successfully';
                response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'Idea delete failed')
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

}
